// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__7dXN+","titleSection":"PageHeader_titleSection__bAt6f","addButton":"PageHeader_addButton__-bk-A"};